module.exports = __webpack_public_path__ + "static/media/fermer-message-membre.1f0354ac.png";